import { render } from "./RenewLicense.vue?vue&type=template&id=031d2144&scoped=true"
import script from "./RenewLicense.vue?vue&type=script&lang=js"
export * from "./RenewLicense.vue?vue&type=script&lang=js"

import "./RenewLicense.vue?vue&type=style&index=0&id=031d2144&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031d2144"]])

export default __exports__